"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nPath = exports.DEFAULT_LOCALE = exports.SUPPORTED_LOCALES = void 0;
/**
 * 支持的语言列表
 */
exports.SUPPORTED_LOCALES = ['vi', 'en', 'zh'];
/**
 * 默认语言
 */
exports.DEFAULT_LOCALE = 'vi';
/**
 * 共享的国际化路由配置
 */
class I18nPath {
    /**
     * 设置额外的本地化路径
     * @param extraPaths 额外的本地化路径映射
     */
    static setPaths(extraPaths) {
        I18nPath.localizedPaths = Object.assign(Object.assign({}, I18nPath.basePath), extraPaths);
    }
    static getPaths() {
        if (!I18nPath.localizedPaths) {
            I18nPath.localizedPaths = Object.assign({}, I18nPath.basePath);
        }
        return I18nPath.localizedPaths;
    }
    /**
     * 生成反向映射：从本地化路径到原始路径
     */
    static generateReverseRouteMap() {
        const reverseMap = {};
        Object.entries(I18nPath.I18N_ROUTE_CONFIG).forEach(([locale, routes]) => {
            reverseMap[locale] = {};
            Object.entries(routes).forEach(([originalPath, localizedPath]) => {
                reverseMap[locale][localizedPath] = originalPath;
            });
        });
        return reverseMap;
    }
}
exports.I18nPath = I18nPath;
I18nPath.basePath = {
    HOME: '/',
    RECOMMEND: '/recommend',
    SEARCH: '/search',
    COMPANY: '/company',
    COMPANY_DETAIL: '/company/[companyName]/[companyId]',
    JOB_DETAIL: '/search/[jobName]/[jobId]',
    LOGIN: '/login',
};
I18nPath.I18N_ROUTE_CONFIG = {
    // 越南语路由映射
    vi: {
        [I18nPath.basePath.COMPANY]: '/cong-ty',
        [I18nPath.basePath.SEARCH]: '/tim-viec-lam',
        [I18nPath.basePath.RECOMMEND]: '/viec-lam-phu-hop',
        [I18nPath.basePath.JOB_DETAIL]: '/tim-viec-lam/[jobName]/[jobId]',
        [I18nPath.basePath.COMPANY_DETAIL]: '/cong-ty/[companyName]/[companyId]',
    },
    // 中文路由映射
    zh: {},
    // 英文保持原样（默认）
    en: {},
};
/**
 * 检查路径是否应该被中间件处理
 */
I18nPath.shouldProcessPath = (pathname) => {
    // 排除 API 路由
    if (pathname.startsWith('/api/')) {
        return false;
    }
    // 排除 Next.js 内部路由
    if (pathname.startsWith('/_next/')) {
        return false;
    }
    // 排除静态文件
    const staticExtensions = [
        '.ico',
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.svg',
        '.webp',
        '.woff',
        '.woff2',
        '.ttf',
        '.eot',
        '.css',
        '.js',
        '.json',
        '.xml',
        '.txt',
    ];
    if (staticExtensions.some((ext) => pathname.toLowerCase().endsWith(ext))) {
        return false;
    }
    // 排除特定路径
    const excludePaths = [
        '/favicon.ico',
        '/robots.txt',
        '/sitemap.xml',
        '/manifest.json',
        '/.well-known',
    ];
    if (excludePaths.some((path) => pathname.startsWith(path))) {
        return false;
    }
    return true;
};
